import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { Layout } from "@components/site/Layout"

export default defineView("single-journal", (props) => {
  return (
    <Layout headerStyle={props.journal?.pageOptions?.headerStyle || "light"}>
      <ContentBlocks blocks={props.journal?.contentBlocks} />
    </Layout>
  )
})
